<p>These Terms of Use, together with the Privacy Policy & Cookie Policy, constitute the sole and entire agreement between Subscriber and Company with respect to the Services and supersedes all prior and contemporaneous understandings, agreements, representations, warranties or terms and conditions, both written and oral, with respect to the Services.
</p>

